import { RequestAppointmentService } from './request-appointment.service';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ValidationService } from '../../shared/services/validation.service';
import { NgForm, FormControl, FormBuilder, FormGroup, Validators, ReactiveFormsModule, AbstractControl } from '@angular/forms';
import { SharedModule } from '../../shared/shared.module';
import { Utility } from '../../common/utility';
import { Appointment, PartyType, MemberModel } from '../../models/request-appointment/appointment.model';
import { DialogService } from '../../shared/services/dialog.service';
import { log } from 'util';
import { AppConstants } from '../../shared/constants/constants';

@Component({
  selector: 'request-appointment',
  templateUrl: 'request-appointment.component.html',
  providers: [RequestAppointmentService]
})
export class RequestAppointmentComponent implements OnInit {
  public partyType = PartyType;
  public appointmentForm: FormGroup;
  public requestAppointmentModel = new Appointment();
  public memeberModel = new MemberModel();
  public member: any;
  public errorPattern = {
    tripCountries: 0
  };
  public centreId: string;
  public countriesOption = [];
  public tripCountries = [];
  public bookingTypeData = [];
  public centreData = [];
  public durationData = [];
  public reasonTripData = [];

  // Feature CR06
  // public reasonData = [];

  public typeAccommodationData = [];
  public destinationTypes: any[];
  public paymentTermData = [];
  public countryData = [];
  public appConstants = AppConstants;
  public timeModel = {
    startMinutes: '',
    startHour: '',
    endMinutes: '',
    endHour: ''
  };
  public clinics = [];

  constructor(
    private router: Router,
    private activeRouter: ActivatedRoute,
    public utility: Utility,
    private formBuilder: FormBuilder,
    public dialogService: DialogService,
    public requestAppointmentService: RequestAppointmentService) {
      this.createForm();

  }

  ngOnInit() {
    this.centreId = this.activeRouter.snapshot.params['id'] || null;
    this.initData();
    this.getInformationMember();

  }

  createForm() {
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);
    this.appointmentForm = this.formBuilder.group({
      bookingType: ['', [Validators.required]],
      centreId: ['', [Validators.required]],
      // clinicId: ['', [Validators.required]],
      departDate: [currentDate, [Validators.required]],
      returnDate: [currentDate, [Validators.required]],
      typeAccommodation: ['', [Validators.required]],
      travelDestination: ['', [Validators.required]],
      reasonTrip: ['', [Validators.required]],
      // reason: [''], // Feature CR06
      note: [''],
      // Group form
      groupName: [''],
      paymentTerm: ['']
    });
  }

  initCache() {
    if (this.centreId != null) {
      this.requestAppointmentService.getBookingCache(this.centreId).subscribe(
        result => {
          if (result.json()) {
            this.requestAppointmentModel = result.json();
            this.appointmentForm.controls['departDate'].setValue(this.requestAppointmentModel.departDate);
            this.appointmentForm.controls['returnDate'].setValue(this.requestAppointmentModel.returnDate);
            // set destination from booking cache
            this.tripCountries = this.requestAppointmentModel.travelDestination;
            const tempArr = [];
            this.requestAppointmentModel.travelDestination.forEach(des => {
              this.countryData.forEach(country => {
                if (des.id === country.id) {
                  country['destinationTypeId'] = des['destinationTypeId'];
                  tempArr.push(country);
                }
              });
            });
            this.requestAppointmentModel.travelDestination = tempArr;
            this.countriesOption = tempArr;
          }
        }, error => {
          return;
        }
      );
    }
  }

  changeCentre(centreId) {
    // call api get clinic by centreId
    // set clinicId = null every change centre
    // this.clinics = [
    //   {
    //     id: 1,
    //     name: 'clinic 1'
    //   },
    //   {
    //     id: 2,
    //     name: 'clinic 2'
    //   },
    //   {
    //     id: 3,
    //     name: 'clinic 3'
    //   },
    //   {
    //     id: 4,
    //     name: 'clinic 4'
    //   },
    // ];
    // this.appointmentForm.controls.clinicId.setValue(null);
  }

  onChangePartyType(event) {
    const type = event.target.value;
    if (type == this.partyType.Individual) {
      ValidationService.removeRequired(this.appointmentForm.controls['groupName'], []);
      ValidationService.removeRequired(this.appointmentForm.controls['paymentTerm'], []);
    } else {
      ValidationService.attachRequired(this.appointmentForm.controls['groupName'], []);
      ValidationService.attachRequired(this.appointmentForm.controls['paymentTerm'], []);
    }
  }

  onSelectOption(country, item) {
    const index = this.countriesOption.findIndex(t => t.id === country.id);
    if (index !== -1) {
      this.countriesOption[index].destinationTypeId = item;
    } else {
      const temp = country;
      temp['destinationTypeId'] = item;
      this.countriesOption.push(temp);
    }
    this.appointmentForm.controls['travelDestination'].setValue(this.countriesOption);
  }

  getInformationMember() {
    this.requestAppointmentService.getPatientDetail(localStorage.getItem(this.appConstants.activeLink.userId)).subscribe(
      (result) => {
        if (result) {
          const data = result.json();
          this.memeberModel = data;
          this.memeberModel.partyType = data['partyTypeId'];
          this.memeberModel.Title = data['titleId'];

        }
      }
    );
  }
  onSubmit() {
    const pattern = {
      'tripCountries': this.countriesOption,
    };

    if (this.isValidData(pattern) && this.appointmentForm.valid) {
      this.requestAppointmentModel = this.appointmentForm.value;
      this.requestAppointmentModel.listMembers = new Array<MemberModel>();
      this.requestAppointmentModel.listMembers.push(this.memeberModel);

      if (this.requestAppointmentModel.bookingType == this.partyType.Individual) {
        this.requestAppointmentService.addBookingCache(this.requestAppointmentModel).subscribe(
          result => {
            if (result) {
              this.onViewCalendar();
            }
          }
        );
      } else if (this.requestAppointmentModel.bookingType == this.partyType.Group) {
        this.requestAppointmentService.addBookingCache(this.appointmentForm.value).subscribe(
          result => {
            if (result) {
              this.onAddMember();
            }
          }
        );
      }

    }
  }

  onAddMember() {
    this.router.navigate(['request-appointment/list-member', this.requestAppointmentModel.centreId]);
  }

  onViewCalendar() {
    this.router.navigate(['view-schedule', this.requestAppointmentModel.centreId]);
  }

  isValidData(data) {
    this.errorPattern.tripCountries = 0;

    if (data.tripCountries.length !== this.tripCountries.length) {
      this.errorPattern.tripCountries = 1;
    }
    if (this.errorPattern.tripCountries === 1) {
      return false;
    }
    return true;
  }

  getCountryData() {
    this.requestAppointmentService.getUserCountryList().subscribe(
      (result) => {
        if (result) {
          this.countryData = result.json();

          // get booking cache
          this.initCache();
        }
      });
  }
  initData() {
    this.requestAppointmentService.getAllCentre().subscribe(
      result => {
        if (result) {
          this.centreData = result.json();
        }
      }
    );
    this.getCountryData();
    this.requestAppointmentService.getInit().subscribe(
      (result) => {
        if (result) {
          const data = result.json();
          let bookingTypes = Array<any>();
          bookingTypes = data['bookingTypes'];
          bookingTypes.forEach(element => {
            if (element.name != 'Flu Vaccine') {
              this.bookingTypeData.push(element);
            }
          });
          this.reasonTripData = data['tripReason'];
          this.typeAccommodationData = data['accommodationTypes'];
          let paymentTerms = Array<any>();
          paymentTerms = data['paymentTerm'];
          paymentTerms.forEach(element => {
            if (element !== '30 days from invoices date') {
              this.paymentTermData.push(element);
            }
          });
          this.destinationTypes = data['destinationTypes'];
        }
      }
    );


    // Feature CR06
    // Data test. Should push in this.requestAppointmentService.getInit()
    // this.reasonData = [
    //   { id: 'ao388', name: 'Test 1', colour: '#000000', isActive: true },
    //   { id: 'ao389', name: 'Test 2', colour: '#ffffff', isActive: false },
    //   { id: 'ao384', name: 'Test 3', colour: '#ffffff', isActive: true },
    //   { id: 'ao382', name: 'Test 4', colour: '#cccccc', isActive: false },
    // ];

  }

  onChangeDestination() {
    const newDestination = this.requestAppointmentModel.travelDestination;
    let selectDestination;
    // default checked
    if (this.tripCountries.length < newDestination.length) {
      selectDestination = newDestination.filter(item => {
        return this.tripCountries.findIndex(country => country.id === item.id) < 0;
      })[0];
      this.onSelectOption(selectDestination, this.destinationTypes[0].id);
    }

    this.tripCountries = this.requestAppointmentModel.travelDestination;
    // reset country option chose when change destionation
    const tempArr = [];
    this.tripCountries.forEach(item => {
      this.countriesOption.forEach(option => {
        if (item.id === option.id) {
          tempArr.push(option);
        }
      });
    });
    this.countriesOption = tempArr;
  }

  /**
   * on input from date input event
   * @param event
   */
  onFromDateInput(event) {
    ValidationService.validationDate(this.appointmentForm.controls['departDate'], event);
  }

  /**
   * on change from date input event : format the date and set
   * @param event
   */
  onFromDateChange(event) {
    this.requestAppointmentService.validateDateRange(this.appointmentForm.controls['departDate'],
      this.appointmentForm.controls['returnDate'], true);
  }

  /**
   * on input from date inpput event
   * @param event
   */
  onToDateInput(event) {
    ValidationService.validationDate(this.appointmentForm.controls['returnDate'], event);
  }

  /**
   * on change from date input event : format the date and set
   * @param event
   */
  onToDateChange(event) {
    this.requestAppointmentService.validateDateRange(this.appointmentForm.controls['departDate'],
      this.appointmentForm.controls['returnDate'], false);
  }

}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/request-appointment/request-appointment.component.ts